import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '@/components/Navbar';

const ServiceDetailsPage = () => {
  const { serviceId } = useParams();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold">Service Details</h1>
        <p>Service ID: {serviceId}</p>
      </div>
    </div>
  );
};

export default ServiceDetailsPage;